import React, { useState, useEffect } from 'react';
import { searchDrug } from '../api/fda';

function SearchBar({ setDrugData, setLoading, setError, externalQuery, setExternalQuery }) {
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (externalQuery && externalQuery.trim()) {
      setQuery(externalQuery);
      handleSearch(externalQuery);
      setExternalQuery('');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalQuery]);

  const handleSearch = async (searchTerm) => {
    const term = searchTerm || query;
    if (!term.trim()) return;
    setLoading(true);
    setError(null);
    setDrugData(null);
    try {
      const data = await searchDrug(term);
      setDrugData(data);
    } catch (err) {
      setError('No data found for that drug. Try a different name or spelling.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="search-container">
      <input
        type="text"
        className="search-input"
        placeholder="Search a drug (e.g. minoxidil, accutane, semaglutide)"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <button className="search-button" onClick={() => handleSearch()}>
        Search
      </button>
    </div>
  );
}

export default SearchBar;